if (!customElements.get('yc-block11')) {
  class YcBlock11 extends HTMLElement {
    connectedCallback() {
      if (this.dataset.singleRow !== 'true') return;

      this.scroller = this.querySelector('.yc-block11__items');
      this.prevButton = this.querySelector('.yc-block11__arrow--prev');
      this.nextButton = this.querySelector('.yc-block11__arrow--next');

      if (!this.scroller || !this.prevButton || !this.nextButton || this.bound) return;

      this.bound = true;
      this.onScroll = () => this.updateArrows();
      this.onPrev = () => this.scrollByStep(-1);
      this.onNext = () => this.scrollByStep(1);
      this.mobileQuery = window.matchMedia('(max-width: 989px)');
      this.onMediaChange = () => this.updateArrows();

      this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
      this.prevButton.addEventListener('click', this.onPrev);
      this.nextButton.addEventListener('click', this.onNext);
      this.mobileQuery.addEventListener('change', this.onMediaChange);

      this.observer = new ResizeObserver(() => {
        this.positionArrows();
        this.updateArrows();
      });
      this.observer.observe(this.scroller);

      this.positionArrows();
      this.updateArrows();
    }

    disconnectedCallback() {
      if (!this.bound) return;

      this.scroller.removeEventListener('scroll', this.onScroll);
      this.prevButton.removeEventListener('click', this.onPrev);
      this.nextButton.removeEventListener('click', this.onNext);
      this.mobileQuery.removeEventListener('change', this.onMediaChange);
      this.observer.disconnect();
      this.bound = false;
    }

    positionArrows() {
      const item = this.scroller.querySelector('.yc-block11__module');
      const track = this.querySelector('.yc-block11__track');
      if (!item || !track) return;

      const itemRect = item.getBoundingClientRect();
      const trackRect = track.getBoundingClientRect();
      const center = itemRect.top - trackRect.top + itemRect.height / 2;
      this.style.setProperty('--arrow-center', `${center}px`);
    }

    updateArrows() {
      if (!this.mobileQuery.matches) {
        this.setArrow(this.prevButton, false);
        this.setArrow(this.nextButton, false);
        if (this.scroller.scrollLeft !== 0) this.scroller.scrollLeft = 0;
        return;
      }

      const maxScroll = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
      const scrollLeft = this.scroller.scrollLeft;
      const canScroll = maxScroll > 4;

      this.setArrow(this.prevButton, canScroll && scrollLeft > 4);
      this.setArrow(this.nextButton, canScroll && scrollLeft < maxScroll - 4);
    }

    setArrow(button, visible) {
      button.hidden = !visible;
      button.disabled = !visible;
    }

    scrollByStep(direction) {
      const item = this.scroller.querySelector('.yc-block11__module');
      if (!item) return;

      const styles = window.getComputedStyle(this.scroller);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      const step = item.getBoundingClientRect().width + gap;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.scroller.scrollBy({
        left: direction * step,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    }
  }

  customElements.define('yc-block11', YcBlock11);
}
